import { STAR1SupportedEGiftCards, STAR1SupportedGiftCards } from '@storefront/lib-global/utils/internationalization';
import type { SupportedGiftCardTypes } from '../types';

export const getSupportedGiftCardType = (locale: string | undefined): SupportedGiftCardTypes => {
  if (!locale)
    return {
      physical: false,
      digital: false,
    };
  const isPhysicalSupported = STAR1SupportedGiftCards.some(
    (supportedLocale) => supportedLocale.toLowerCase() === locale.toLowerCase(),
  );
  const isDigitalSupported = STAR1SupportedEGiftCards.some(
    (supportedLocale) => supportedLocale.toLowerCase() === locale.toLowerCase(),
  );

  return {
    physical: isPhysicalSupported,
    digital: isDigitalSupported,
  };
};
